import { StyledButtonProps } from './types'

export const getButtonFontSize = (size: StyledButtonProps['$size']) => {
  switch (size) {
    case 'small':
      return '.85rem'

    case 'xsmall':
      return '.75rem'

    default:
      return '0.9rem'
  }
}

export const getButtonRadius = (size: StyledButtonProps['$size']) => {
  switch (size) {
    case 'small':
      return '0.75rem'

    case 'xsmall':
      return '0.5rem'

    default:
      return '0.75rem'
  }
}

export const getButtonPadding = (size: StyledButtonProps['$size']) => {
  switch (size) {
    case 'small':
      return '0.4rem 0.6rem'

    case 'xsmall':
      return '0.25rem 0.4rem'

    default:
      return '0.4rem 0.6rem'
  }
}
